
import React, { useState } from 'react';
import { Share2, Check, UserPlus, Loader2 } from 'lucide-react';
import { supabase } from '../supabaseClient';

export const ShareApp = () => {
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShare = async () => {
    setLoading(true);
    try {
        // 1. Get User Info for Personalization
        const { data: { user } } = await supabase.auth.getUser();
        let userName = 'Um colega da Rhino';
        if (user) {
             userName = user.user_metadata?.full_name || 
                        user.user_metadata?.name || 
                        (user.email ? user.email.split('@')[0] : 'Um colega');
             userName = userName.charAt(0).toUpperCase() + userName.slice(1);
        }

        // 2. Build Link and Message
        const inviteLink = `${window.location.origin}?ref=${user?.id || 'anon'}&name=${encodeURIComponent(userName)}`;
        const shareText = `Fala parceiro! Tô usando o Driver Score pra organizar meus ganhos e acompanhar as metas aqui da Rhino. 🚀\n\nAchei sensacional e usei o app pra te mandar esse convite. Se você entrar por esse link e assinar o Modo Elite EM ATÉ 30 DIAS, nós dois ganhamos 3 MESES DE GRAÇA na hora! 🎁\n\nClica aí e dá uma olhada: ${inviteLink}`;

        const shareData = {
          title: 'Convite Driver Score',
          text: shareText,
          url: inviteLink,
        };

        // 3. Show Alert about the benefit
        // window.alert("🎁 BÔNUS DE INDICAÇÃO!\n\nSe o seu amigo criar a conta por esse link e assinar o Modo Elite EM ATÉ 30 DIAS, VOCÊ e ELE ganham 3 MESES GRÁTIS de assinatura!\n\nCompartilhe agora mesmo.");

        // 4. Share
        if (navigator.share) {
          try {
            await navigator.share({
              title: 'Convite Driver Score',
              text: shareText,
              // We include the URL explicitly as well, but some apps prefer it in the text
              url: inviteLink 
            });
          } catch (shareErr) {
            // If user cancelled, don't fallback. If it failed, try clipboard
            if ((shareErr as Error).name !== 'AbortError') throw shareErr;
          }
        } else {
          // Fallback to WhatsApp direct if on mobile, or clipboard
          const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          if (isMobile) {
            window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
          } else {
            await navigator.clipboard.writeText(shareText);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          }
        }
    } catch (err) {
        console.log('Error sharing:', err);
    } finally {
        setLoading(false);
    }
  };

  return (
    <button
      onClick={handleShare}
      disabled={loading}
      className={`
        flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all shadow-sm
        ${copied 
          ? 'bg-green-100 text-green-700 border border-green-200' 
          : 'bg-blue-600 text-white hover:bg-blue-700 active:scale-95'}
      `}
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : (copied ? <Check size={18} /> : <UserPlus size={18} />)}
      {loading ? 'Gerando...' : (copied ? 'Link Copiado!' : 'Convidar Colegas')}
    </button>
  );
};
